<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">

				<!-- <FormItem label="货道编号" prop="number" class="sj">
					<Input v-model="formValidate.number" placeholder="请输入货道编号" disabled></Input>
				</FormItem> -->
				<FormItem label="货道编号" prop="aisleIds" class="sj">
					<Select v-model="formValidate.aisleIds" multiple filterable clearable remote
						:remote-method="remoteMethod2" :loading="loading2">
						<Option v-for="(item,i) in aisles" :key="i" :value="item.id">{{item.number}}</Option>
					</Select>
				</FormItem>

				<FormItem label="商品名称" prop="operComm.id" class="sj">
					<Select placeholder="请输入商品名称" v-model="formValidate.operComm.id" remote :filterable="true"
						:remote-method="remoteMethod1" :loading="loading1" @on-change="onchange"> <!--  filterable remote-->
						<Option value="0">暂无</Option>
						<Option v-for="item in coms" :key="item.id" :value="item.id">
							{{item.name}}({{item.specification}}-{{item.manuString}})
						</Option>
					</Select>
				</FormItem>
				<FormItem label="售价" prop="sellPrice" class="sj">
					<Input v-model="formValidate.sellPrice" placeholder="商品售价" type="number"></Input>
				</FormItem>
				<FormItem label="最大数量" prop="maxNumber" class="sj">
					<Input v-model="formValidate.maxNumber" placeholder="请输入最大库存量" type="number"></Input>
				</FormItem>
				<FormItem label="当前数量 " prop="currentMayNumber" class="sj">
					<Input v-model="formValidate.currentMayNumber" placeholder="请输入当前库存量" type="number" @on-change="onChangeDqsl"></Input>
				</FormItem>
				<FormItem label="待出货数量" prop="currentNoMayNumber" class="sj">
					<Input v-model="formValidate.currentNoMayNumber" placeholder="请输入当前库存量" type="number"
						disabled="disabled"></Input>
				</FormItem>
				<FormItem label="库存报警数" prop="minNumber" class="sj">
					<Input v-model="formValidate.minNumber" placeholder="请输入库存报警数" type="number"></Input>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="tijiaoClick()">提交</Button>
				</FormItem>
			</Form>
			<Modal v-model="modal1" title="请选择生产日期" :footer-hide='true'>
				<Scroll :on-reach-bottom="handleReachBottom" height="600">

					<div style="height: 600px;">
						<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
							<FormItem label="有效期" prop="expirationTimeNumber" class="sj">
								<Input v-model="formValidate.expirationTimeNumber" placeholder="请输入有效期"
									type="number" >
									 <span slot="append">天</span>
									</Input>
							</FormItem>
							<FormItem label="预警阀值" prop="remindTimeNumber" class="sj">
								<Input v-model="formValidate.remindTimeNumber" placeholder="请输入报警阀值"
									type="number"   >
									 <span slot="append">天</span>
								</Input>
							</FormItem>
							<div>选择生产日期</div>
							<FormItem prop="expiryDate" class="sj" v-for="(item,index) in expiryDate" :key="index"
								:label="index+1">
								<DatePicker type="date" placeholder="请选择日期" v-model="expiryDate[index]">
								</DatePicker>
							</FormItem>
							<FormItem>
								<Button type="primary" @click="quedingClick()">确定</Button>
							</FormItem>
						</Form>
					</div>

				</Scroll>
			</Modal>
		</div>
	</div>
</template>

<script>
	let _this
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				shuliang: 0,
				modal1: false,
				ii: 0,
				macId: '',
				loading1: false,
				loading2: false,
				formValidate: {
					id: '',
					aisleIds: [],
					operComm: {
						id: '',
					},
					number: '',
					maxNumber: '',
					currentMayNumber: '',
					currentNoMayNumber: '',
					minNumber: '',
					sellPrice: 0,
					expirationTimeNumber: '',
					remindTimeNumber: '',
					expiryDate: []
				},
				expiryDate: [],
				aisles: [],
				coms: [],
				ruleValidate: {
					// 'expiryDate': [{
					// 	required: true,
					// 	message: '请选择日期！！！',
					// 	trigger: 'blur'
					// }],
					// 'expirationTimeNumber': [{
					// 	required: true,
					// 	message: '货期不能为空！！！',
					// 	trigger: 'blur'
					// }],
					// 'remindTimeNumber': [{
					// 	required: true,
					// 	message: '报警阀值不能为空！！！',
					// 	trigger: 'blur'
					// }],
					'sellPrice': [{
						required: true,
						message: '商品售价不能为空！！！',
						trigger: 'blur'
					}],
					'operComm.id': [{
						required: true,
						message: '商品不能为空！！！',
						trigger: 'blur'
					}],
					'aisleIds': [{
						required: true,
						message: '货道编号不能为空！！！',
						trigger: 'blur',
						type: 'array'
					}],
					maxNumber: [{
						required: true,
						message: '最大库存量不能为空！！！',
						trigger: 'blur'
					}],
					currentMayNumber: [{
						required: true,
						message: '当前库存量不能为空！！！',
						trigger: 'blur'
					}],
					minNumber: [{
						required: true,
						message: '报警库存量不能为空！！！',
						trigger: 'blur'
					}]

				}

			}
		},
		methods: {
			onChangeDqsl(){
				
			},
			tijiaoClick() {
				if (this.formValidate.aisleIds.length == 0) {
					this.$Message.error('请先选择货道!');
					return;
				}
				if(this.formValidate.operComm.id==null || this.formValidate.operComm.id==''){
					this.$Message.error('请先选择商品!');
					return;
				}
				if(this.formValidate.operComm.id == 0){
					_this.handleSubmit('formValidate')
					return ;
				}
				
				
				if (this.formValidate.sellPrice <= 0) {
					this.$Message.error('售价必须大于0!');
					return;
				}
				if (this.formValidate.aisleIds.length == 0) {
					this.$Message.error('请先选择货道!');
					return;
				}
				if (!(/(^[1-9]\d*$)/.test(this.formValidate.maxNumber))) {
					this.$Message.error('最大库存量必须大于0!');
					return;
				}
				if (!(/(^[1-9]\d*$)/.test(this.formValidate.minNumber))) {
					this.$Message.error('最小库存量必须大于0!');
					return;
				}
				if (!(/(^[0-9]\d*$)/.test(this.formValidate.currentMayNumber))) {
					this.$Message.error('当前数量必须为整数!');
					return;
				}
				if (parseInt(this.formValidate.maxNumber) < parseInt(this.formValidate.minNumber) && parseInt(this
						.formValidate.minNumber) !=
					0) {

					this.$Message.error('最大库存量必须大于库存报警量!');
					return;
				}
				if (parseInt(this.formValidate.maxNumber) < (parseInt(this.formValidate.currentMayNumber)) && parseInt(this
						.formValidate
						.currentMayNumber) != 0) {
					this.$Message.error('最大库存量必须大于当前数量!');
					return;
				}
				if (parseInt(this.formValidate.currentMayNumber) < parseInt(this.formValidate.currentNoMayNumber)) {
					this.$Message.error('当前数量必须大于等于待出货数量!');
					return;
				}
				if(this.macKind=='KFJ'){
					_this.handleSubmit('formValidate')
				}else{
					if (this.formValidate.operComm.id != null && this.formValidate.operComm.id != ''  && this.formValidate.operComm.id != 0) { //选择了商品
						
						if (_this.shuliang != _this.formValidate.currentMayNumber || _this.formValidate.expiryDate == null ||
							_this.formValidate.expiryDate.length != _this.formValidate.currentMayNumber || _this.formValidate.expiryDate.length==0) {
							
							if(_this.formValidate.expiryDate==null || parseInt(_this.formValidate.currentMayNumber)>_this.formValidate.expiryDate.length){
								
								if(_this.formValidate.expiryDate==null){
									_this.formValidate.expiryDate=[]
								}
								_this.expiryDate=_this.formValidate.expiryDate
								let aa1=parseInt( _this.formValidate.currentMayNumber)-_this.formValidate.expiryDate.length
								console.log(aa1)
								for (var i = 0; i <aa1; i++) {
									console.log(1)
									_this.expiryDate.push("")
								}
								_this.shuliang=_this.formValidate.currentMayNumber
							}else{
								_this.formValidate.expiryDate = []
								_this.expiryDate = []
								for (var i = 0; i < this.formValidate.currentMayNumber; i++) {
									_this.formValidate.expiryDate.push('')
									_this.expiryDate.push('')
								}	
							}
							
							
						} else {
							_this.expiryDate = _this.formValidate.expiryDate
						}
						_this.modal1 = true
					} else {
						_this.handleSubmit('formValidate')
					}
				}
				


				// _this.handleSubmit('formValidate')
			},
			onchange(id) {
				let aaa = id.toString()
				for (let i = 0; i < this.coms.length; i++) {
					console.log(id, this.coms[i].id)
					if (this.coms[i].id == aaa) {
						this.formValidate.sellPrice = this.coms[i].sellPrice / 100 + ''

					}
				}
			},
			remoteMethod1(query) {
				if (query !== '') {
					let a = query.split('(')
					this.queryComms(a[0])
				} else {
					this.coms = [];
				}
			},
			remoteMethod2(query) {
				if (query !== '') {
					this.ajaxPage(query)
				} else {
					this.coms = [];
				}
			},
			ret() { //返回上一页
				this.$router.go(-1)
			},

			quedingClick() {
				if(this.formValidate.expirationTimeNumber==null || this.formValidate.expirationTimeNumber=='' ){
					this.$Message.error('请输入有效期!');
					return;
				}
				if(this.formValidate.remindTimeNumber==null || this.formValidate.remindTimeNumber=='' ){
					this.$Message.error('请输入警戒阀值!');
					return;
				}
				
				if(parseInt(this.formValidate.expirationTimeNumber)>3600 || parseInt(this.formValidate.expirationTimeNumber)<1){
					this.$Message.error('请输入正确的有效期!');
					return;
				}
				
				if(parseInt(this.formValidate.remindTimeNumber)>3600 || parseInt(this.formValidate.remindTimeNumber)<1){
					this.$Message.error('请输入正确的警戒阀值!');
					return;
				}
				if(parseInt(this.formValidate.expirationTimeNumber)<=parseInt(this.formValidate.remindTimeNumber)){
					this.$Message.error('有效期必须大于警戒阀值!');
					return;
				}
				for (var i = 0; i < _this.expiryDate.length; i++) {
					let a = _this.expiryDate[i]
					var date = new Date(a)
					var y = date.getFullYear()
					var m = date.getMonth() + 1
					m = m < 10 ? ('0' + m) : m
					var d = date.getDate()
					d = d < 10 ? ('0' + d) : d
					const time = y + '-' + m + '-' + d
					if (time == null || time == '' || time == 'NaN-NaN-NaN') {
						this.$Message.error('请选择日期!');
						return;
					}
					this.formValidate.expiryDate[i] = time
				}
				console.log(this.formValidate)
				_this.handleSubmit('formValidate')
			},
			handleSubmit(name) {



				this.$refs[name].validate((valid) => {
					if (valid) {

						let d = {
							id: this.formValidate.id,
							aisleIds: this.formValidate.aisleIds,
							operComm: {
								id: this.formValidate.operComm.id
							},
							maxNumber: this.formValidate.maxNumber,
							currentMayNumber: parseInt(this.formValidate.currentMayNumber) - parseInt(this
								.formValidate.currentNoMayNumber),
							minNumber: this.formValidate.minNumber,
							sellPrice: Number((this.formValidate.sellPrice * 100).toFixed(2)),
							expirationTimeNumber: this.formValidate.expirationTimeNumber,
							remindTimeNumber: this.formValidate.remindTimeNumber,
							expiryDate: this.formValidate.expiryDate
						}
						_this.modal1 = false
						
						_this.shuliang = _this.formValidate.currentMayNumber
						http.http({
							//这里是你自己的请求方式、url和data参数
							method: 'post',
							url: http.url + '/mac/leave/factory/aisle/oper/update/comm',
							data: d,
							_this: _this,
							success: function(data) {
								_this.$Message.success('修改成功!!!');
							}
							//假设后台需要的是表单数据这里你就可以更改
						})

					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})

			},
			handleReset(name) {
				this.$refs[name].resetFields();
			},
			queryComms(query) {
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/oper/operComMerchandise/page',
					data: {
						page: 0,
						size: 20,
						like: query,
						macId: _this.macId
					},
					_this: _this,
					success: function(data) {
						_this.coms = data.page.content
						this.loading1 = true;
					}
					//假设后台需要的是表单数据这里你就可以更改
				})

			},
			ajaxPage(query) {
				//this.loading = true
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/mac/leave/factory/aisle/page/oper',
					data: {
						page: 0,
						size: 20,
						macId: _this.macId,
						like: query
					},
					_this: _this,
					success: function(data) {
						//_this.total = data.aisles.totalElements
						_this.aisles = data.aisles.content

						//_this.loading = false
					}
					//假设后台需要的是表单数据这里你就可以更改
				})

			},
		},
		created() {
			//查询所有商品
			_this = this

			_this.macKind = this.$route.query.macKind
			_this.macId = this.$route.query.macId
			//_this.ajaxPage()

			this.formValidate.id = this.$route.query.id

			http.http({
				//这里是你自己的请求方式、url和data参数
				method: 'post',
				url: http.url + '/mac/leave/factory/aisle/get',
				data: {
					id: this.formValidate.id
				},
				_this: _this,
				success: function(data) {
					_this.formValidate.operComm.id = data.aisle.operComm.id
					_this.formValidate.sellPrice = data.aisle.sellPrice / 100 + ''
					_this.formValidate.aisleIds.push(data.aisle.id)
					_this.formValidate.number = data.aisle.number + ""
					_this.formValidate.maxNumber = data.aisle.maxNumber + '',
						_this.formValidate.currentMayNumber = data.aisle.currentMayNumber + data.aisle
						.currentNoMayNumber + '',
						_this.formValidate.currentNoMayNumber = data.aisle.currentNoMayNumber + '',
						_this.formValidate.minNumber = data.aisle.minNumber + ''
					_this.formValidate.expirationTimeNumber = data.aisle.expirationTimeNumber==null?'': data.aisle.expirationTimeNumber+''
					_this.formValidate.remindTimeNumber = data.aisle.remindTimeNumber==null?'': data.aisle.remindTimeNumber+''
					_this.formValidate.expiryDate = data.aisle.expiryDate
					let aa = {
						id: data.aisle.id,
						number: _this.formValidate.number
					}
					_this.aisles.push(aa)
					let aa1 = {
						id: data.aisle.operComm.id,
						name: data.aisle.operComm.name,
						manuString: data.aisle.operComm.manuString,
						specification: data.aisle.operComm.specification,
					}
					_this.coms.push(aa1)
					_this.shuliang = _this.formValidate.currentMayNumber
				}
				//假设后台需要的是表单数据这里你就可以更改
			})

		},
		//设置返回不刷新数据
		beforeRouteLeave(to, from, next) {
			to.meta.keepAlive = true;
			next();
		},
	}
</script>

<style scoped="scoped">
	.ivu-select-input{
		
	}
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/mac/aisle/update.vue